/**
 * Which rule made a deposit necessary. Recorded on the deposit itself so it
 * can still be explained once the settings behind it have moved on.
 */
export enum DepositRequirementSource {
  None = 'none',
  Patient = 'patient',
  /** A staff member added a deposit even though no rule required one. */
  Staff = 'staff',
  /** A deposit configured against the Treatment Configurations being booked. */
  TreatmentConfiguration = 'treatmentConfiguration',
  /** A deposit rule set on the booking's Treatment Template. */
  TreatmentTemplate = 'treatmentTemplate',
  BookingContextExcluded = 'bookingContextExcluded',
  AppointmentDayExcluded = 'appointmentDayExcluded',
}
